module.exports = __webpack_public_path__ + "img/icon-edit.a8365778.svg";